import { defineComponent, ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15e9d0dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top_operate"
};
const _hoisted_2 = {
  class: "top_extra"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
      required: true
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    maxTagCount: {
      type: [String, Number],
      default: 1
    },
    showTopOperate: {
      type: Boolean,
      default: true
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    filterOption: {
      type: Function
    },
    selectType: {
      type: String
    },
    popupContainer: {
      type: HTMLElement
    }
  },
  emits: ['update:modelValue', 'change', 'cancel', 'ok'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const VNodes = defineComponent({
      props: {
        vnodes: {
          type: Object,
          required: true
        }
      },
      render() {
        return this.vnodes;
      }
    });
    const checkedAllFilter = ref(false);
    const dropdownOpen = ref(false);
    const selectedValues = ref([...props.modelValue]);
    const initialSelectedValues = ref([...props.modelValue]); // 点击取消的时候 还原筛选项
    const isInitial = ref(true); // 用来判断是否需要更新初始值的开关
    const searchValue = ref(''); // 搜索关键字
    const canCloseDropDown = ref(false); // 是否可以关闭下拉选项面板
    const searchFilterOption = ref([]); // 搜索筛选过后的选项
    // 全选和取消全选操作
    const changeCheckedAllFilter = () => {
      if (checkedAllFilter.value) {
        var _searchFilterOption$v;
        searchFilterOption.value = props.options.filter(option => option.label.toLowerCase().includes(searchValue.value.toLowerCase()));
        selectedValues.value = ((_searchFilterOption$v = searchFilterOption.value) === null || _searchFilterOption$v === void 0 ? void 0 : _searchFilterOption$v.map(item => item.value)) || [];
      } else {
        onClearFilter();
      }
      handleChange(selectedValues.value);
    };
    // 清空操作
    const onClearFilter = () => {
      checkedAllFilter.value = false;
      selectedValues.value = [];
      handleChange(selectedValues.value);
    };
    // 反选操作
    const onReverseFilter = () => {
      var _props$options$filter;
      selectedValues.value = (_props$options$filter = props.options.filter(item => !selectedValues.value.includes(item.value))) === null || _props$options$filter === void 0 ? void 0 : _props$options$filter.map(item => item.value);
      initCheckedAllFilter();
      handleChange(selectedValues.value);
    };
    // 更新是否全选
    const initCheckedAllFilter = () => {
      checkedAllFilter.value = props.options.length > 0 && searchFilterOption.value.length > 0 && selectedValues.value.length === searchFilterOption.value.length;
    };
    const handleChange = values => {
      isInitial.value = false;
      selectedValues.value = values;
      emit('update:modelValue', values);
      emit('change', values);
      // 如果是当选项panel关闭的时候，点击右侧的清空按钮或者点击单个取消tag标签取消的，此时清空全选状态，并调用接口
      if (!dropdownOpen.value) {
        checkedAllFilter.value = false;
        handleOk();
      }
    };
    const handleSearch = value => {
      searchValue.value = value;
    };
    const handleCancel = () => {
      handleCanCloseDropDown();
      selectedValues.value = [...initialSelectedValues.value];
      emit('update:modelValue', selectedValues.value);
      emit('cancel');
      // 关闭下拉菜单
      handleDropdownVisibleChange(false);
    };
    const handleOk = () => {
      handleCanCloseDropDown();
      isInitial.value = true;
      // 更新初始选中的值为当前选中的值
      initialSelectedValues.value = [...selectedValues.value];
      emit('update:modelValue', selectedValues.value);
      emit('ok');
      // 关闭下拉菜单
      handleDropdownVisibleChange(false);
    };
    const handleDropdownVisibleChange = open => {
      if (!open && canCloseDropDown.value) {
        dropdownOpen.value = false;
      } else {
        dropdownOpen.value = true;
      }
      if (open) {
        // 强制刷新选项列表，防止出现下拉选项空白
        setTimeout(() => {
          selectedValues.value = [...props.modelValue];
          initCheckedAllFilter();
        }, 10);
      }
    };
    const handleCanCloseDropDown = () => {
      canCloseDropDown.value = true;
    };
    watch(() => props.modelValue, newVal => {
      selectedValues.value = [...newVal];
      if (isInitial.value) {
        initialSelectedValues.value = [...newVal];
      }
      initCheckedAllFilter();
    });
    expose({
      handleCanCloseDropDown
    });
    return (_ctx, _cache) => {
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      return _openBlock(), _createBlock(_component_a_select, _mergeProps({
        class: "multiple_select",
        value: selectedValues.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => selectedValues.value = $event),
        mode: "multiple",
        "max-tag-count": __props.maxTagCount,
        searchValue: searchValue.value,
        filterOption: __props.filterOption,
        showArrow: "",
        optionFilterProp: "label",
        showSearch: "",
        allowClear: __props.allowClear
      }, _ctx.$attrs, {
        open: dropdownOpen.value,
        onDropdownVisibleChange: handleDropdownVisibleChange,
        onChange: handleChange,
        onSearch: handleSearch,
        getPopupContainer: triggerNode => __props.popupContainer || triggerNode.parentNode
      }), {
        dropdownRender: _withCtx(({
          menuNode: menu
        }) => [__props.showTopOperate ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {
            canCloseDropDown.value = false;
          }, ["stop"]))
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_a_checkbox, {
          checked: checkedAllFilter.value,
          "onUpdate:checked": _cache[0] || (_cache[0] = $event => checkedAllFilter.value = $event),
          onChange: changeCheckedAllFilter
        }, {
          default: _withCtx(() => [_createTextVNode("全选")]),
          _: 1
        }, 8, ["checked"])]), _createElementVNode("div", null, [_createElementVNode("a", {
          class: "mr",
          onClick: onReverseFilter
        }, "反选"), _createElementVNode("a", {
          onClick: onClearFilter
        }, "清空")])]), _renderSlot(_ctx.$slots, "extraOperate"), _createVNode(_component_a_divider, {
          style: {
            "margin": "4px 0"
          }
        }), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "topExtra")])])) : _createCommentVNode("", true), _createVNode(_unref(VNodes), {
          vnodes: menu
        }, null, 8, ["vnodes"]), _createVNode(_component_a_divider, {
          style: {
            "margin": "4px 0"
          }
        }), _createVNode(_component_a_space, {
          style: {
            padding: '4px 8px',
            display: 'flex',
            justifyContent: 'flex-end'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            size: "small",
            onClick: _withModifiers(handleCancel, ["stop"])
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: _withModifiers(handleOk, ["stop"])
          }, {
            default: _withCtx(() => [_createTextVNode("确定")]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.value,
            value: item.value,
            label: item.label
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, [_createElementVNode("span", null, _toDisplayString(item.label), 1)])]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 3
      }, 16, ["value", "max-tag-count", "searchValue", "filterOption", "allowClear", "open", "getPopupContainer"]);
    };
  }
});